<div class="quote-breakdown" *ngIf="quoteBreakdown$ | async as quoteBreakdown" data-qa="quoteBreakdown">
  <div class="quote-breakdown__section" *ngIf="quoteBreakdown.course">
    <lx-quote-breakdown-section
      [price]="quoteBreakdown.course.price"
      [endPrice]="quoteBreakdown.course.endPrice"
      [currency]="currency$ | async"
      data-qa="quoteBreakdown_course"
    >
      <ng-container ngProjectAs="product" i18n> Course </ng-container>
      <div class="quote-breakdown__product__item__info" *ngIf="courseDetails$ | async as courseDetails">
        <div class="quote-breakdown__product__item__info__line" *ngIf="(activeFlow$ | async) !== Flows.Online">
          {{ courseDetails.selectedSchoolLocation?.countryName }} - {{ courseDetails.selectedSchoolLocation?.schoolName }}
        </div>
        <div class="quote-breakdown__product__item__info__line">
          {{ courseDetails.selectedCourse?.name }}
        </div>
        <div class="quote-breakdown__product__item__info__line">
          {{ courseDetails.selectedStartDate | lxStudyPeriod : courseDetails.selectedEndDate : courseDetails.selectedDuration }}
        </div>
      </div>
    </lx-quote-breakdown-section>
  </div>
  <div class="quote-breakdown__section" *ngIf="quoteBreakdown.accommodation">
    <lx-quote-breakdown-section
      [price]="quoteBreakdown.accommodation.price"
      [endPrice]="quoteBreakdown.accommodation.endPrice"
      [currency]="currency$ | async"
      data-qa="quoteBreakdown_accommodation"
    >
      <ng-container ngProjectAs="product" i18n> Accommodation </ng-container>
      <div class="quote-breakdown__product__item__info">
        <div class="quote-breakdown__product__item__info__line">
          {{ quoteBreakdown.accommodation.name }} ({{ quoteBreakdown.accommodation.units | lxDurationUnitsLabel }})
        </div>
        <div class="quote-breakdown__product__item__info__line">
          {{ quoteBreakdown.accommodation.description }}
        </div>
      </div>
    </lx-quote-breakdown-section>
  </div>

  <div class="quote-breakdown__section" *ngIf="quoteBreakdown.premiumActivities">
    <lx-quote-breakdown-section
      [price]="quoteBreakdown.premiumActivities.prices.price"
      [endPrice]="quoteBreakdown.premiumActivities.prices.endPrice"
      [currency]="currency$ | async"
      data-qa="quoteBreakdown_accommodation"
    >
      <ng-container ngProjectAs="product" i18n> Premium Activities </ng-container>
      <div class="quote-breakdown__product__item__info">
        <div class="quote-breakdown__product__item__info__line" *ngFor="let premiumActivity of quoteBreakdown.premiumActivities.activities">
          {{ premiumActivity.name }} ({{ premiumActivity.units | lxDurationUnitsLabel }})
        </div>
      </div>
    </lx-quote-breakdown-section>
  </div>

  <div class="quote-breakdown__section" *ngIf="quoteBreakdown.premiumAccommodation">
    <lx-quote-breakdown-section
      [price]="quoteBreakdown.premiumAccommodation.price"
      [endPrice]="quoteBreakdown.premiumAccommodation.endPrice"
      [currency]="currency$ | async"
      data-qa="quoteBreakdown_premiumAccommodation"
    >
      <ng-container ngProjectAs="product" i18n> Premium Accommodation </ng-container>
      <div class="quote-breakdown__product__item__info">
        <div class="quote-breakdown__product__item__info__line">
          {{ quoteBreakdown.premiumAccommodation.units | lxDurationUnitsLabel }}
        </div>
      </div>
    </lx-quote-breakdown-section>
  </div>

  <div class="quote-breakdown__section" *ngIf="quoteBreakdown.transfer">
    <lx-quote-breakdown-section
      [price]="quoteBreakdown.transfer.prices?.price"
      [endPrice]="quoteBreakdown.transfer.prices?.endPrice"
      [currency]="currency$ | async"
      data-qa="quoteBreakdown_transfer"
    >
      <ng-container ngProjectAs="product" i18n> Transfer </ng-container>
      <div class="quote-breakdown__product__item__info">
        <div class="quote-breakdown__product__item__info__line" *ngFor="let transfer of quoteBreakdown.transfer.transfers">
          {{ transfer.name }}
        </div>
      </div>
    </lx-quote-breakdown-section>
  </div>

  <div class="quote-breakdown__section" *ngIf="quoteBreakdown.unaccompaniedMinorServices">
    <lx-quote-breakdown-section
      [price]="quoteBreakdown.unaccompaniedMinorServices.price"
      [endPrice]="quoteBreakdown.unaccompaniedMinorServices.endPrice"
      [currency]="currency$ | async"
      data-qa="quoteBreakdown_unaccompaniedMinorServices"
    >
      <ng-container ngProjectAs="product" i18n> Alpadia UM Services </ng-container>
      <div class="quote-breakdown__product__item__info">
        <div class="quote-breakdown__product__item__info__line" i18n>Arrival & Departure</div>
      </div>
    </lx-quote-breakdown-section>
  </div>

  <div class="quote-breakdown__section" *ngIf="quoteBreakdown.privateLessons">
    <lx-quote-breakdown-section
      [price]="quoteBreakdown.privateLessons.price"
      [endPrice]="quoteBreakdown.privateLessons.endPrice"
      [currency]="currency$ | async"
      data-qa="quoteBreakdown_privateLessons"
    >
      <ng-container ngProjectAs="product" i18n> Private Lessons </ng-container>
      <div class="quote-breakdown__product__item__info">
        <div class="quote-breakdown__product__item__info__line">
          {{ quoteBreakdown.privateLessons.units | lxDurationUnitsLabel }}
        </div>
      </div>
    </lx-quote-breakdown-section>
  </div>

  <div class="quote-breakdown__section" *ngIf="quoteBreakdown.insurance">
    <lx-quote-breakdown-section
      [price]="quoteBreakdown.insurance.price"
      [endPrice]="quoteBreakdown.insurance.endPrice"
      [currency]="currency$ | async"
      data-qa="quoteBreakdown_insurance"
    >
      <ng-container ngProjectAs="product" i18n> Insurance </ng-container>
      <div class="quote-breakdown__product__item__info">
        <div class="quote-breakdown__product__item__info__line">
          {{ quoteBreakdown.insurance.units | lxDurationUnitsLabel }}
        </div>
      </div>
    </lx-quote-breakdown-section>
  </div>

  <div class="quote-breakdown__section" *ngIf="quoteBreakdown.professionalImmersionExperience">
    <lx-quote-breakdown-section
      [price]="quoteBreakdown.professionalImmersionExperience.price"
      [endPrice]="quoteBreakdown.professionalImmersionExperience.endPrice"
      [currency]="currency$ | async"
      data-qa="quoteBreakdown_professionalImmersionExperience"
    >
      <ng-container ngProjectAs="product" i18n> Professional Immersion Experience </ng-container>
      <div class="quote-breakdown__product__item__info">
        <div class="quote-breakdown__product__item__info__line">
          {{ quoteBreakdown.professionalImmersionExperience.units | lxDurationUnitsLabel }}
        </div>
      </div>
    </lx-quote-breakdown-section>
  </div>

  <div class="quote-breakdown__section" *ngFor="let feeOrSupplement of quoteBreakdown.feesAndSupplements">
    <lx-quote-breakdown-section
      [price]="feeOrSupplement.price"
      [endPrice]="feeOrSupplement.endPrice"
      [currency]="currency$ | async"
      data-qa="quoteBreakdown_feesAndSupplements"
    >
      <ng-container ngProjectAs="product">
        {{ feeOrSupplement.name }}
      </ng-container>
    </lx-quote-breakdown-section>
  </div>

  <div class="quote-breakdown__section quote-breakdown__section--total-price">
    <lx-quote-breakdown-section [endPrice]="(packageDetails$ | async)?.grandTotal" [currency]="currency$ | async" data-qa="quoteBreakdown_totalPrice">
      <ng-container ngProjectAs="product" i18n> Total price </ng-container>
    </lx-quote-breakdown-section>
  </div>

  <div class="quote-breakdown__section quote-breakdown__section--highlight">
    <lx-quote-breakdown-section [endPrice]="depositAmounts$ | async" [currency]="currency$ | async" data-qa="quoteBreakdown_enrolToday">
      <ng-container ngProjectAs="product" i18n> Enrol today for </ng-container>
    </lx-quote-breakdown-section>
  </div>

  <div *ngIf="disclaimer$ | async as disclaimer" class="quote-breakdown__section quote-breakdown__section--disclaimer" data-qa="quoteBreakdown_disclaimer">
    {{ disclaimer }}
  </div>
</div>
